/** El servicio tal como lo hace esa persona: catálogo pisado por sus overrides. */
export function resolverServicio(servicio, personaId, overrides) {
    const overridesPorTramo = new Map(overrides.filter((o) => o.personaId === personaId).map((o) => [o.ordenTramo, o]));
    return {
        ...servicio,
        tramos: servicio.tramos.map((tramo) => {
            const override = overridesPorTramo.get(tramo.orden);
            if (!override)
                return tramo;
            const res = { ...tramo, duracionMin: override.duracionMin ?? tramo.duracionMin };
            if (override.bufferMin !== null && override.bufferMin !== undefined) {
                res.bufferMin = override.bufferMin;
            }
            else {
                delete res.bufferMin;
            }
            return res;
        }),
    };
}
/** El profesional principal de una asignación: la única persona `seleccionablePorCliente` presente. `undefined` si hay cero o más de una distinta. */
export function principalDe(asignacion, tipos, recursos) {
    const recursosTipos = new Map(tipos.map((t) => [t.id, t]));
    const recursosInfo = new Map(recursos.map((r) => [r.id, r]));
    const principales = new Set();
    for (const tramo of asignacion) {
        for (const rec of tramo.recursos) {
            const recurso = recursosInfo.get(rec.recursoId);
            if (recurso) {
                const tipo = recursosTipos.get(recurso.tipoId);
                if (tipo?.esPersona && tipo.seleccionablePorCliente) {
                    principales.add(recurso.id);
                }
            }
        }
    }
    return principales.size === 1 ? Array.from(principales)[0] : undefined;
}
//# sourceMappingURL=cascada.js.map